const product = {
    bosidun: {
        name: '波斯顿瓶 / 瓶盖',
        data: [
            {
                name: '波斯顿15ml瓶',
                img: "/image/img/15ml.8543f3e.jpg",
                contect: '波斯顿15ml瓶'
            },

            {
                name: '波斯顿30ml瓶',
                img: "/image/img/30ml.b09a6da.jpg",
                contect: '波斯顿30ml瓶'
            },
            {
                name: '波斯顿60ml瓶',
                img: "/image/img/60ml.3d92d07.jpg",
                contect: '波斯顿60ml瓶'
            },
            {
                name: '波斯顿120ml瓶',
                img: "/image/img/120ml.e05c74f.jpg",
                contect: '波斯顿120ml瓶'
            },
            {
                name: '波斯顿240ml瓶',
                img: "/image/img/240ml.b791134.jpg",
                contect: '波斯顿240ml瓶'
            },
            {
                name: '波斯顿480ml瓶',
                img: "/image/img/480ml.1d62430.jpg",
                contect: '波斯顿480ml瓶'
            },
            {
                name: '波斯顿15ml瓶盖',
                img: "/image/img/IMG_0849.34b813e.jpg",
                contect: '波斯顿15ml瓶盖'
            },
            {
                name: '波斯顿30ml瓶盖',
                img: "/image/img/IMG_0853.ca6e072.jpg",
                contect: '波斯顿30ml瓶盖'
            },
            {
                name: '波斯顿60ml瓶盖',
                img: "/image/img/IMG_0859.24635cb.jpg",
                contect: '波斯顿60ml瓶盖'
            },
            {
                name: '波斯顿120ml瓶盖',
                img: "/image/img/IMG_0860.3a83cfe.jpg",
                contect: '波斯顿120ml瓶盖'
            },
            {
                name: '波斯顿240ml瓶盖',
                img: "/image/img/IMG_0863.5fe2df2.jpg",
                contect: '波斯顿240ml瓶盖'
            },
            {
                name: '波斯顿480ml瓶盖',
                img: "/image/img/IMG_0867.604cdba.jpg",
                contect: '波斯顿480ml瓶盖'
            },
        ]
    },
    guangkou: {
        name: '广口瓶',
        data: [
            {
                name: '广口瓶50ml',
                img: "/image/img/pic/guangkouping/50ml.JPG",
                contect: '广口瓶50ml'
            },
            {
                name: '广口瓶60ml',
                img: "/image/img/pic/guangkouping/60ml.JPG",
                contect: '广口瓶60ml'
            },
            {
                name: '广口瓶75ml',
                img: "/image/img/pic/guangkouping/75ml.JPG",
                contect: '广口瓶75ml'
            },
            {
                name: '广口瓶100ml',
                img: "/image/img/pic/guangkouping/100ml.JPG",
                contect: '广口瓶100ml'
            },
            {
                name: '广口瓶120ml',
                img: "/image/img/pic/guangkouping/120ml.JPG",
                contect: '广口瓶120ml'
            },
            {
                name: '广口瓶150ml',
                img: "/image/img/pic/guangkouping/150ml.JPG",
                contect: '广口瓶150ml'
            },
            {
                name: '广口瓶250ml',
                img: "/image/img/pic/guangkouping/250ml.JPG",
                contect: '广口瓶250ml'
            },
            {
                name: '广口瓶500ml',
                img: "/image/img/pic/guangkouping/500ml.JPG",
                contect: '广口瓶500ml'
            },
        ]
    },
    gunzhu: {
        name: '滚珠瓶',
        data: [
            {
                name: '滚珠瓶5ml(1)',
                img: "/image/img/5ml1.70cebbd.jpg",
                contect: '滚珠瓶5ml(1)'
            },
            {
                name: '滚珠瓶8ml',
                img: "/image/img/8ml.f0fb32d.jpg",
                contect: '滚珠瓶8ml'
            },
            {
                name: '滚珠瓶10ml(1)',
                img: "/image/img/10ml1.97fee4d.jpg",
                contect: '滚珠瓶10ml(1)'
            },
            {
                name: '滚珠瓶10ml(2)',
                img: "/image/img/10ml2.eec672f.jpg",
                contect: '滚珠瓶10ml(2)'
            },
            {
                name: '滚珠瓶10ml',
                img: "/image/img/10ml.615a7ca.jpg",
                contect: '滚珠瓶10ml'
            },
        ]
    },
    koufuye: {
        name: '口服液瓶',
        data: [
            {
                name: '口服液瓶20ml',
                img: "/image/img/20ml.5b18009.jpg",
                contect: '口服液瓶20ml'
            },
            {
                name: '口服液瓶30ml',
                img: "/image/img/30ml.49e6e58.jpg",
                contect: '口服液瓶30ml'
            },
            {
                name: '口服液瓶50ml',
                img: "/image/img/50ml.0371faa.jpg",
                contect: '口服液瓶50ml'
            },
            {
                name: '口服液瓶60mlZD',
                img: "/image/img/60mlZD.c48c40e.jpg",
                contect: '口服液瓶60mlZD'
            },
            {
                name: '口服液瓶125ZD',
                img: "/image/img/125ZD.b3ad01a.jpg",
                contect: '口服液瓶125ZD'
            },
            {
                name: '口服液瓶250ml',
                img: "/image/img/250ml.d3d2aac.jpg",
                contect: '口服液瓶250ml'
            },
        ]
    },
    lvgai: {
        name: '铝盖系列',
        data: [
            {
                name: '18号铝盖',
                img: "/image/img/IMG_0984.6913e97.jpg",
                contect: '18号铝盖'
            },
            {
                name: '22号铝盖',
                img: "/image/img/IMG_0965.d2f5102.jpg",
                contect: '22号铝盖'
            },
            {
                name: '25号铝盖',
                img: "/image/img/IMG_0964.48ec7e8.jpg",
                contect: '25号铝盖'
            },
            {
                name: '啤酒盖',
                img: "/image/img/IMG_0934.a20dc45.jpg",
                contect: '啤酒盖'
            },
        ]
    },
    lvsejingyou: {
        name: '绿色精油瓶',
        data: [
            {
                name: '绿色精油瓶10ml',
                img: "/image/img/10ml.43813ca.jpg",
                contect: '绿色精油瓶10ml'
            },
            {
                name: '绿色精油瓶15ml',
                img: "/image/img/15ml.2874927.jpg",
                contect: '绿色精油瓶15ml'
            },
            {
                name: '绿色精油瓶20ml',
                img: "/image/img/20ml.ab46b67.jpg",
                contect: '绿色精油瓶20ml'
            },
            {
                name: '绿色精油瓶30ml',
                img: "/image/img/30ml.b839316.jpg",
                contect: '绿色精油瓶30ml'
            },
            {
                name: '绿色精油瓶50ml',
                img: "/image/img/50ml.53600cd.jpg",
                contect: '绿色精油瓶50ml'
            },
            {
                name: '绿色精油瓶100ml',
                img: "/image/img/100ml.e9f7fba.jpg",
                contect: '绿色精油瓶100ml'
            },
        ]
    },
    mokang: {
        name: '模抗瓶',
        data: [
            {
                name: '模抗瓶10ml',
                img: "/image/img/10ml.62b7d78.jpg",
                contect: '模抗瓶10ml'
            },
            {
                name: '模抗瓶20ml',
                img: "/image/img/20ml.4ca25b0.jpg",
                contect: '模抗瓶20ml'
            },
            {
                name: '模抗瓶30ml',
                img: "/image/img/30ml.87636d0.jpg",
                contect: '模抗瓶30ml'
            },
            {
                name: '模抗瓶50ml',
                img: "/image/img/50ml.98ed289.jpg",
                contect: '模抗瓶50ml'
            },
            {
                name: '模抗瓶100ml',
                img: "/image/img/100ml.345dff4.jpg",
                contect: '模抗瓶100ml'
            },
        ]
    },
    pijiu: {
        name: '啤酒瓶',
        data: [
            {
                name: '啤酒瓶200ml',
                img: "/image/img/200ml.6c3c892.jpg",
                contect: '啤酒瓶200ml'
            },
            {
                name: '啤酒瓶296ml',
                img: "/image/img/296ml.3079731.jpg",
                contect: '啤酒瓶296ml'
            },
            {
                name: '啤酒瓶330ml',
                img: "/image/img/330ml.8273aa1.jpg",
                contect: '啤酒瓶330ml'
            },

        ]
    },
    toumingjingyou: {
        name: '透明精油瓶',
        data: [
            {
                name: '透明精油瓶10ml',
                img: "/image/img/10ml.9a127c7.jpg",
                contect: '透明精油瓶10ml'
            },
            {
                name: '透明精油瓶20ml',
                img: "/image/img/20ml.a9686e8.jpg",
                contect: '透明精油瓶20ml'
            },
            {
                name: '透明精油瓶30ml',
                img: "/image/img/30ml.b014712.jpg",
                contect: '透明精油瓶30ml'
            },
            {
                name: '透明精油瓶50ml',
                img: "/image/img/50ml.11d0d90.jpg",
                contect: '透明精油瓶50ml'
            },
            {
                name: '透明精油瓶100ml',
                img: "/image/img/100ml.8fae96e.jpg",
                contect: '透明精油瓶100ml'
            },

        ]
    },
    toumingmukang: {
        name: '透明模抗瓶',
        data: [
            {
                name: '透明模抗瓶7ml',
                img: "/image/img/7ml.803e496.jpg",
                contect: '透明模抗瓶7ml'
            },
            {
                name: '透明模抗瓶10ml',
                img: "/image/img/10ml.032cb49.jpg",
                contect: '透明模抗瓶10ml'
            },
            {
                name: '透明模抗瓶20ml',
                img: "/image/img/20ml.c228758.jpg",
                contect: '透明模抗瓶20ml'
            },
            {
                name: '透明模抗瓶30ml',
                img: "/image/img/30ml.3b15abb.jpg",
                contect: '透明模抗瓶30ml'
            },
            {
                name: '透明模抗瓶50ml',
                img: "/image/img/50ml.fb410c3.jpg",
                contect: '透明模抗瓶50ml'
            },
            {
                name: '透明模抗瓶100ml',
                img: "/image/img/100ml.2ae2929.jpg",
                contect: '透明模抗瓶100ml'
            },

        ]
    },
    zongsejingyou: {
        name: '棕色精油瓶',
        data: [
            {
                name: '棕色精油瓶5ml',
                img: "/image/img/5ml.38b1abc.jpg",
                contect: '棕色精油瓶5ml'
            },
            {
                name: '棕色精油瓶10ml',
                img: "/image/img/10ml.94a0c2b.jpg",
                contect: '棕色精油瓶10ml'
            },
            {
                name: '棕色精油瓶15ml',
                img: "/image/img/15ml.080d5fd.jpg",
                contect: '棕色精油瓶15ml'
            },
            {
                name: '棕色精油瓶20ml',
                img: "/image/img/20ml.d74d978.jpg",
                contect: '棕色精油瓶20ml'
            },
            {
                name: '棕色精油瓶30ml',
                img: "/image/img/30ml.fc9c40c.jpg",
                contect: '棕色精油瓶30ml'
            },
            {
                name: '棕色精油瓶50ml',
                img: "/image/img/50ml.dcac620.jpg",
                contect: '棕色精油瓶50ml'
            },
            {
                name: '棕色精油瓶100ml',
                img: "/image/img/100ml.e5426cb.jpg",
                contect: '棕色精油瓶100ml'
            },

        ]
    },
}
module.exports = product
